import React from 'react';
import styles from './ErrorBoundary.module.sass';

interface ErrorFallbackProps {
  message: string;
  onReload?: () => void;
}

const ErrorFallback: React.FC<ErrorFallbackProps> = ({ message, onReload }) => {
  const handleReload = () => {
    if (onReload) {
      onReload();
    } else {
      window.location.reload();
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <img src="/images/large-solink.png" alt="Solink" className={styles.logo} />
        <h1 className={styles.title}>Something went wrong</h1>
        <p className={styles.message}>{message}</p>
        <button onClick={handleReload} className={styles.reloadButton}>
          Reload Page
        </button>
      </div>
    </div>
  );
};

/**
 * Wrapper that makes its children take over the full viewport.
 * Use to wrap ErrorFallback for top-level error boundaries.
 */
export const FullPageWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <div className={styles.fullPageWrapper}>{children}</div>;
};

export default ErrorFallback;
